/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
import{c as r}from"../../../../chunks/vec3f64.js";import{VertexNormalDrawParameters as s}from"../core/shaderLibrary/attributes/VertexNormal.glsl.js";class i extends s{constructor(s=r()){super(),this.origin=s,this.slicePlaneLocalOrigin=this.origin}}export{i as DrawParameters};
